module.exports = __webpack_public_path__ + "static/img/01.ce2e8b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/01.png
// module id = F5hj
// module chunks = 1